<template>
    <div>
        <div class='social-bg' v-show="$i18n.locale==='zh'">
            <el-image :src="campus_header" style=" width: 100%; margin-bottom: 3%"></el-image>
            <el-image :src="social_title" style=" width: 100%; margin-bottom: 3%"></el-image>
            <div class='campus-list'>
                <div class="campus-item">
                    <el-image :src="campus_welfare" class="campus-img"></el-image>
                </div>
                <div class="campus-item-job">
<!--                    <el-row :gutter="0" style="margin-top: 10%">-->
<!--                        <el-col v-for="job in job_list" :span="8" :key="job.name">-->
<!--                            <router-link :to="'/join_social_details?job_name='+job.name" style="position:relative;">-->
<!--                                <el-image :src="'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/'+ job.name +'.png'" style="margin: 4% 0; position: relative;">-->
<!--                                </el-image>-->
<!--                            </router-link>-->
<!--                        </el-col>-->
<!--                    </el-row>-->
                    <el-image :src="social_job_bg" class="campus-img"></el-image>
                    <el-row :gutter="0" class="job-row">
                        <el-col v-for="job in job_list" :span="6" :key="job.name" class="jon-el-col">
                            <router-link :to="'/join_social_details?job_name='+job.name" style="position:relative;" v-if="!job.name.includes('null_')">
                                <el-image :src="job.img" class="job-col-img" alt=""></el-image>
                            </router-link>
                            <div v-else><p></p></div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <div class='social-bg' v-show="$i18n.locale==='en'">
           <el-image :src="campus_header_en" style=" width: 100%; margin-bottom: 3%"></el-image>
           <div class="campus-item">
                <el-image :src="social_en" class="campus-img"></el-image>
            </div>
        </div>
    </div>
</template>

<script>
export default {
data(){
        return {
            //和校园招聘引入资源基本相同
            campus_header: `${require('../assets/resource_10_23/zhaopin_header.jpg')}`,
            campus_header_en: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/campus_header_en_new.jpg',
            social_en: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/social_en.png',
            social_title: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/social_title.png',
            campus_welfare: `${require('../assets/resource_10_23/fuli_1.png')}`,
            social_job_bg: `${require('../assets/resource_10_23/zhaopin_1.png')}`,
            campus_up: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/campus_up.png',
            job_list: []
        }
    },
    created() {
        this.getJson();
    },
    methods: {
        getJson() {
            const json = require('../assets/json/new_social_job.json');
            const data = Object.keys(json);
            this.job_list = data.map((item) => {
                if (item.includes('null_')) {
                    return {name: item}
                } else {
                    return {
                        name: item,
                        img: `${require('../assets/resource_10_23/' + item + '.jpg')}`,
                    };
                }
            })
        }
    }
}
</script>

<style>
    .campus-item, .campus-item-job {
        margin-left: auto;
        margin-right: auto;
        display: block;
        margin-top: 50px;
    }
    .campus-item {
        width: 90%;
    }
    .campus-item-job {
        width: 60%;
        position: relative;
    }
    .campus-img{
        width: 100%;
    }
    .job-row {
        margin-top: 15%;
        position: absolute;
        left: 0px;
        top: 0px;
    }
    .jon-el-col {
        position: relative;
    }
    .job-col-img {
        margin: 4% 0;
        position: relative;
        width: 80%;
    }
@media screen and (max-width: 992px) {
    .campus-item {
        width: 120%;
        position: relative;
        right: 10%;
    }
    .campus-item, .campus-item-job {
        margin-top: 20px;
    }
    .campus-item-job {
        width: 80%;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/JoinUsSocial.vue